import {
  OneToOneRawTextMessage,
  OneToOneRawAudioMessage,
  RawFriendRequestMessage,
} from "@/store/chats/types";
import { markMessageAsReadBeAsync } from "./markMessageAsReadBeAsync";

interface IMarkOneToOneMessageAsReadObject {
  message:
    | OneToOneRawTextMessage
    | OneToOneRawAudioMessage
    | RawFriendRequestMessage;
  accessToken: string;
}

export const markOneToOneMessageAsRead = async ({
  message,
  accessToken,
}: IMarkOneToOneMessageAsReadObject) => {
  if (message.read) {
    return;
  }
  await markMessageAsReadBeAsync({
    messageId: message.id,
    accessToken,
  });
};
